module.exports = __webpack_public_path__ + "img/home.5d692318.png";